// disable_on_submit_controller.js
// Disables the form's submit button once the form is submitted, to prevent
// duplicate submissions from an accidental double-click - needed for forms
// that opt out of Turbo (data-turbo="false"), since Turbo itself already
// disables the submitter for the duration of the request.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    const submitter = this.element.querySelector("input[type='submit'], button[type='submit']")
    if (submitter) {
      submitter.disabled = true
    }
  }
}
